import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { uiActions } from 'state/modules/UI';

import Button from '@material-ui/core/Button';
import MaterialTable from '@material-table/core';
import Box from '@material-ui/core/Box';

const EditableTable = ({
  data,
  isEditHidden,
  isDeleteHidden,
  onEdit,
  columns,
  onDelete,
  onRowAdd,
  addButtonProps,
  requiredFields,
  onRowAddCancelled,
  onRowUpdateCancelled,
}) => {
  const dispatch = useDispatch();
  const tableRef = useRef();

  const [editable, setEditable] = useState({
    isEditHidden,
    isDeleteHidden,
    onRowUpdate: (newData, oldData) =>
      new Promise((resolve, reject) => {
        if (validateFields(newData)) {
          dispatch(
            uiActions.handleShowSnackbar({
              type: 'error',
              message: 'Missing data for required fields',
            })
          );
          reject();
        } else {
          onEdit(newData, resolve, reject, oldData);
        }
      }),
    onRowDelete: (data) =>
      new Promise((resolve, reject) => {
        onDelete(data, resolve, reject);
      }),
    onRowAddCancelled,
    onRowUpdateCancelled,
  });

  const validateFields = (fields) => {
    let errors = {};
    requiredFields.map((field) => {
      if (!fields[field]) {
        errors[field] = true;
      }
      return true;
    });

    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleAddRow = () => {
    tableRef.current.state.showAddRow = true;
    setEditable((prevState) => {
      return {
        ...prevState,
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            if (validateFields(newData)) {
              dispatch(
                uiActions.handleShowSnackbar({
                  type: 'error',
                  message: 'Missing data for required fields',
                })
              );
              reject();
            } else {
              onRowAdd(newData, resolve, reject);
            }
          }),
      };
    });
  };

  return (
    <div className="editableTable">
      <MaterialTable
        tableRef={tableRef}
        options={{
          search: false,
          paging: false,
          toolbar: false,
          actionsColumnIndex: -1,
          headerStyle: {
            backgroundColor: '#FBFBFB',
            color: '#2C2C2E',
            fontSize: '0,875rem',
            fontWeight: 400,
          },
        }}
        style={{
          fontSize: 14,
        }}
        columns={columns}
        data={data}
        editable={editable}
      />
      <Box mt={2} display="flex" justifyContent={addButtonProps.position}>
        <Button
          style={{ textTransform: 'capitalize' }}
          startIcon={addButtonProps.startIcon}
          variant={addButtonProps.variant}
          data-cy={addButtonProps['dataCy'] || 'add-button-editableTable'}
          onClick={handleAddRow}
          color="primary"
          size="medium"
        >
          {addButtonProps.label}
        </Button>
      </Box>
    </div>
  );
};

EditableTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  columns: PropTypes.array,
  onRowAdd: PropTypes.func,
  addButtonProps: PropTypes.object,
};

EditableTable.defaultProps = {
  data: [],
  columns: [],
  loading: false,
  onRowAdd: () => {},
  addButtonProps: {
    label: 'Add new',
    variant: 'outlined',
    position: 'flex-end',
  },
};

export default EditableTable;
